import HealthScoreQuestionnaire from "@/features/HealthScore/components/HealthScoreQuestionnaire";
import {
  Question,
  QuestionnaireAnswer,
  QuestionType,
  QuestionnaireType,
  MentalWellbeingFrequency,
} from "@/features/HealthScore/components/HealthScoreQuestionnaire/types";
import { useTranslation } from "react-i18next";

export default function MentalWellbeingQuestionnaire() {
  const { t } = useTranslation();

  const FREQUENCY_VALUES = [
    MentalWellbeingFrequency.NOT_AT_ALL,
    MentalWellbeingFrequency.SEVERAL_DAYS,
    MentalWellbeingFrequency.MORE_THAN_HALF,
    MentalWellbeingFrequency.NEARLY_EVERYDAY,
  ];

  const MENTAL_WELLBEING_QUESTIONS: Question[] = [
    {
      type: QuestionType.NERVOUS_OR_ON_EDGE,
      meta: {
        description: true,
        values: FREQUENCY_VALUES,
      },
    },
    {
      type: QuestionType.UNCONTROLLABLE_WORRY,
      meta: {
        description: true,
        values: FREQUENCY_VALUES,
      },
    },
    {
      type: QuestionType.LOW_INTEREST_OR_PLEASURE,
      meta: {
        description: true,
        values: FREQUENCY_VALUES,
      },
    },
    {
      type: QuestionType.FEELING_DOWN_OR_HOPELESS,
      meta: {
        description: true,
        values: FREQUENCY_VALUES,
      },
    },
  ];

  const handleSubmit = async (answers: QuestionnaireAnswer[]) => {
    const payload = {
      questionnaireType: QuestionnaireType.MENTAL_WELLBEING,
      value: answers,
    };
    // TODO: Replace with actual API call
    console.log("Submitting mental wellbeing answers:", payload);
  };

  return (
    <HealthScoreQuestionnaire
      questions={MENTAL_WELLBEING_QUESTIONS}
      translationPrefix="MentalWellbeing.questionnaire"
      onSubmit={handleSubmit}
      title={t("MentalWellbeing.questionnaire.title")}
    />
  );
}
